import type { OutcomeHueName } from './outcome-colors';

export function marketOutcomePalette(seed: number): readonly OutcomeHueName[] {
  const palette = MARKET_OUTCOME_PALETTES[seed % MARKET_OUTCOME_PALETTES.length];
  if (palette === undefined) throw new Error('marketOutcomePalette: missing palette');
  return palette;
}

// Opening pairs cross hue families. Valence anchors come last so ordinary
// outcomes in a supported ten-outcome market agree on single and full-set views.
const MARKET_OUTCOME_PALETTES: readonly (readonly OutcomeHueName[])[] = [
  [
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'sky',
    'violet',
    'lime',
    'indigo',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'teal',
    'pink',
    'blue',
    'purple',
    'amber',
    'cyan',
    'yellow',
    'sky',
    'violet',
    'lime',
    'indigo',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'amber',
    'indigo',
    'purple',
    'blue',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'sky',
    'violet',
    'lime',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'cyan',
    'orange',
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'pink',
    'sky',
    'violet',
    'lime',
    'indigo',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'lime',
    'violet',
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'sky',
    'orange',
    'indigo',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'yellow',
    'blue',
    'purple',
    'amber',
    'teal',
    'cyan',
    'pink',
    'sky',
    'violet',
    'lime',
    'indigo',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'teal',
    'purple',
    'blue',
    'amber',
    'cyan',
    'yellow',
    'pink',
    'sky',
    'violet',
    'lime',
    'indigo',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'sky',
    'fuchsia',
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'lime',
    'violet',
    'indigo',
    'emerald',
    'orange',
    'green',
    'red',
  ],
  [
    'amber',
    'cyan',
    'purple',
    'blue',
    'teal',
    'yellow',
    'pink',
    'sky',
    'violet',
    'lime',
    'indigo',
    'orange',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'lime',
    'pink',
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'violet',
    'sky',
    'orange',
    'indigo',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'orange',
    'indigo',
    'purple',
    'blue',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'sky',
    'lime',
    'violet',
    'emerald',
    'fuchsia',
    'green',
    'red',
  ],
  [
    'emerald',
    'violet',
    'blue',
    'purple',
    'amber',
    'teal',
    'yellow',
    'cyan',
    'pink',
    'sky',
    'lime',
    'indigo',
    'orange',
    'fuchsia',
    'green',
    'red',
  ],
];
